import React, {useState, useEffect} from "react"
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import GoogleMap from './GoogleMap';
import SearchBox from './SearchBox';
import {fromLatLng} from '../../utils/geocode';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog({
  handleSubmit = () => null,
  readOnly,
  defaultAddress,
  disabled
}) {
  const {
    addressName: defaultAddressName,
    coordinates: defaultCoordinates
  } = defaultAddress || {}
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const [isMapVisible, setMapVisibility] = useState(true);
  const [address, setAddress] = useState(defaultCoordinates);
  const [addressName, setAddressName] = useState(defaultAddressName);

  useEffect(() => {
    !isMapVisible && setMapVisibility(true);
  }, [address, isMapVisible])

  const handleMarkerClick = (data) => {
  }

  const onMapClick = (data) => {
    if (readOnly) return;
    const coordinates = address
      ? null
      : {
        lat: data.latLng.lat(),
        lng: data.latLng.lng()
      };
    setAddress(coordinates);

    if (address) {
      setAddressName('');
      return;
    }
    fromLatLng(coordinates, (addressName) => {
      setAddressName(addressName)
    })
  };

  const handlePlaceChange = (data) => {
    setMapVisibility(false);
    const location = data[0].geometry.location;
    setAddressName(data[0].formatted_address);
    setAddress({lat: location.lat(), lng: location.lng()});
  }

  const handleInputChange = (e) => {
    setAddressName(e.target.value);
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setAddressName(defaultAddressName);
    setAddress(defaultCoordinates);

    setOpen(false);
  };

  const onSave = () => {
    handleSubmit({
      coordinates: address,
      addressName
    })
    setOpen(false);
  }

  return (
    <div>
      <div className='address-modal-opener'>
        <div className='address-modal-opener__label'>
          {defaultAddressName ? defaultAddressName : 'Address is not specified'}
        </div>
        <div className='address-modal-opener__btn'>
          <Button disabled={disabled} variant="outlined" color="primary" onClick={handleClickOpen}>
            {readOnly ? 'View address' : 'Set address'}
          </Button>
        </div>
      </div>

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {readOnly ? 'Address preview' : 'Select address'}
            </Typography>
            {!readOnly && (
              <Button disabled={!address} autoFocus color="inherit" onClick={onSave}>
                save
              </Button>
            )}
          </Toolbar>
        </AppBar>

        {!readOnly && <SearchBox addressName={addressName} onInputChange={handleInputChange} onPlacesChanged={handlePlaceChange} />}
          {isMapVisible && (
            <GoogleMap
              onMarkerClick={handleMarkerClick}
              onMapClick={onMapClick}
              address={address}
            />
          )}
      </Dialog>
    </div>
  );
}